(()=>{
  const all=(selector,root=document)=>[...root.querySelectorAll(selector)];
  const dock=document.querySelector('.player-dock');
  const frame=document.querySelector('#player-frame');
  let selected='';
  function initMenu(){
    const toggle=document.querySelector('.menu-toggle');
    const nav=document.querySelector('.main-nav');
    if(!toggle||!nav||toggle.dataset.ready==='true')return;toggle.dataset.ready='true';
    const close=()=>{nav.classList.remove('open');toggle.setAttribute('aria-expanded','false')};
    toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));nav.classList.toggle('open',open)});
    nav.addEventListener('click',event=>{if(event.target.closest('a'))close()});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&nav.classList.contains('open')){close();toggle.focus()}});
    matchMedia('(min-width: 761px)').addEventListener('change',close);
  }
  function applyFilter(container,filter){
    all('[data-filter]',container).forEach(button=>{const active=button.dataset.filter===filter;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active))});
    const rows=all('[data-group]',container);rows.forEach(row=>row.hidden=row.dataset.group!==filter);
    const count=container.querySelector('.archive-count');
    if(count)count.textContent=`${rows.filter(row=>!row.hidden).length} ${container.dataset.countSuffix||'VOLUMES / SELECT TO LISTEN'}`;
  }
  function initSections(root=document){
    all('.archive-catalogue',root).forEach(container=>applyFilter(container,container.dataset.defaultGroup||container.querySelector('[data-filter].active')?.dataset.filter||'21'));
    all('.upcoming',root).forEach(section=>{
      const events=all('[data-event]',section);const now=Date.now();
      events.forEach(event=>{const expires=Date.parse(event.dataset.expires);event.hidden=!window.Shopify?.designMode&&section.dataset.hidePast!=='false'&&Number.isFinite(expires)&&expires<=now});
      const empty=section.querySelector('.event-empty');
      if(empty)empty.hidden=events.some(event=>!event.hidden);
    });
  }
  let lastControl=null;
  function play(button){
    const track=button.dataset.track;
    if(!track||!dock||!frame)return;
    let source;
    if(/^\d+$/.test(track))source=`https://api.soundcloud.com/tracks/${track}`;
    else{try{const url=new URL(track);if(!['soundcloud.com','www.soundcloud.com'].includes(url.hostname)||url.protocol!=='https:')return;source=url.href}catch{return}}
    lastControl=button;
    const config=button.dataset.playerOverride==='true'?button.dataset:dock.dataset;
    const option=(key,fallback)=>config['player'+key]||dock.dataset['player'+key]||fallback;
    const visual=option('Visual','false')==='true';
    const params=new URLSearchParams({url:source,color:option('Color','#ff0000'),auto_play:option('Autoplay','true'),hide_related:String(option('Related','false')!=='true'),show_comments:option('Comments','false'),show_reposts:option('Reposts','false'),show_teaser:option('Teaser','false'),visual:String(visual),show_artwork:option('Artwork','true'),show_user:option('User','true')});
    frame.style.height=visual?'300px':'166px';
    const signature=source+'?'+params.toString();
    if(selected!==signature||!frame.src)frame.src='https://w.soundcloud.com/player/?'+params.toString();
    selected=signature;
    dock.hidden=false;frame.hidden=false;
    dock.querySelector('[data-player-title]').textContent=button.dataset.title||'STEV';
    dock.querySelector('[data-player-genre]').textContent=button.dataset.genre||'';
    dock.querySelector('[data-player-announcement]').textContent=`Selected ${button.dataset.title}. SoundCloud player opened.`;
    frame.title=`${button.dataset.title} — SoundCloud player`;
    const minimiser=dock.querySelector('.player-minimise');minimiser.setAttribute('aria-expanded','true');minimiser.textContent=(dock.dataset.labelMinimise||'Minimise')+' −';
    all('[data-play]').forEach(control=>{control.classList.toggle('is-playing',control.dataset.track===track);if(control.hasAttribute('aria-pressed'))control.setAttribute('aria-pressed',String(control.dataset.track===track))});
  }
  document.addEventListener('click',event=>{
    const playButton=event.target.closest('[data-play]');
    if(playButton){play(playButton);return}
    const filter=event.target.closest('[data-filter]');
    if(filter){applyFilter(filter.closest('.archive-catalogue'),filter.dataset.filter);return}
    if(event.target.closest('.player-close')){
      frame.removeAttribute('src');selected='';dock.hidden=true;
      all('[data-play]').forEach(button=>{button.classList.remove('is-playing');if(button.hasAttribute('aria-pressed'))button.setAttribute('aria-pressed','false')});
      if(lastControl&&!lastControl.hidden)lastControl.focus({preventScroll:true});return;
    }
    if(event.target.closest('.player-minimise')){
      frame.hidden=!frame.hidden;const button=dock.querySelector('.player-minimise');button.setAttribute('aria-expanded',String(!frame.hidden));button.textContent=frame.hidden?(dock.dataset.labelExpand||'Expand')+' +':(dock.dataset.labelMinimise||'Minimise')+' −';
    }
  });
  document.addEventListener('submit',event=>{
    if(!event.target.matches('[data-preview-form]'))return;
    event.preventDefault();
    const data=new FormData(event.target);
    const details=['name','email','event','date','venue','body'].map(key=>`${key==='body'?'Message':key[0].toUpperCase()+key.slice(1)}: ${data.get('contact['+key+']')||'Not specified'}`).join('\n\n');
    const subject=`Booking enquiry — ${data.get('contact[event]')||'STEV'}`;
    window.location.href=`mailto:STEV@STEV.COM.AU?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(details)}`;
  });
  initMenu();initSections();
  document.addEventListener('shopify:section:load',event=>{initMenu();initSections(event.target)});
  document.addEventListener('shopify:block:select',event=>{const row=event.target.closest('[data-group]');if(row){const container=row.closest('.archive-catalogue');if(container)applyFilter(container,row.dataset.group)}});
  setInterval(()=>all('.upcoming').forEach(section=>initSections(section.parentElement)),60000);
})();
